import React, {ReactElement, useEffect} from 'react';
import {BrowserRouter, Navigate, Route, Routes, useLocation, useNavigate} from 'react-router';
import CDUploadPage from './components/pages/cdupload/CDUploadPage';
import DicomizePage from './components/pages/dicomize/DicomizePage';
import ObscurlGate from './auth/gates/ObscurlGate';
import ErrorPage, {ErrorParam} from './components/pages/ErrorPage';
import GoogleLoginGate from "./auth/gates/GoogleLoginGate";
import TenantSettingsPage from "./components/pages/admin/TenantSettingsPage";
import GlobalSettingsPage from "./components/pages/admin/GlobalSettingsPage";
import APIKeysPage from "./components/pages/admin/APIKeysPage";
import EventLogsPage from "./components/pages/admin/EventLogsPage";
import ConfigurationsGate from "./auth/gates/ConfigurationsGate";
import {ErrorCode} from "./types/Error";
import {GlobalNavigate} from "./GlobalNavigate";

function normalizeContextPath(path: string): string {
	let normalizedContext = path.startsWith("/") ? path : `/${path}`;
	if (normalizedContext.length > 1 && normalizedContext.endsWith("/")) {
		normalizedContext = normalizedContext.slice(0, -1);
	}
	return normalizedContext;
}

function computeBasenameForUpload(pathname: string | undefined): string {
	if (!pathname) return "/upload";
	const normalized = normalizeContextPath(pathname);
	const idx = normalized.toLowerCase().lastIndexOf("/upload");
	if (idx === -1) {
		return "/upload";
	}
	return normalized.slice(0, idx + "/upload".length);
}

export const PAGES_PATHS = {
	BASE: "upload",
	CD_UPLOAD: "cd-upload",
	DICOMIZE: "dicomize",
	ADMIN: {
		BASE: "admin",
		GLOBAL_SETTINGS: "global-settings",
		TENANT_SETTINGS: "tenant-settings",
		API_KEYS: "api-keys",
		EVENTS: "events"
	},
	ERROR: "error"
};

export default function Entrypoint() {
	const basename = computeBasenameForUpload(window.location.pathname);

	return (
			<BrowserRouter basename={basename}>
				<GlobalNavigate/>
				<div id="main-panel">
					<Routes>
						<Route path="/" element={<ObscurlGate/>}>
							<Route path="/" element={<ConfigurationsGate/>}>
								<Route path={PAGES_PATHS.CD_UPLOAD} element={<CDUploadPage/>}/>
								<Route path={PAGES_PATHS.DICOMIZE} element={<DicomizePage/>}/>
							</Route>
						</Route>

						<Route path={PAGES_PATHS.ADMIN.BASE} element={<GoogleLoginGate/>}>
							<Route index element={<Navigate replace to={PAGES_PATHS.ADMIN.TENANT_SETTINGS}/>}/>
							<Route path={PAGES_PATHS.ADMIN.GLOBAL_SETTINGS} element={<GlobalSettingsPage/>}/>
							<Route path={PAGES_PATHS.ADMIN.TENANT_SETTINGS} element={<TenantSettingsPage/>}/>
							<Route path={PAGES_PATHS.ADMIN.API_KEYS} element={<APIKeysPage/>}/>
							<Route path={PAGES_PATHS.ADMIN.EVENTS} element={<EventLogsPage/>}/>
						</Route>

						<Route path={PAGES_PATHS.ERROR} element={<ErrorPage/>}/>
						<Route path="*" element={<NotFoundPage/>}/>
					</Routes>
				</div>

				<div id="zeero-popups-root"></div>
			</BrowserRouter>
	);
}

const NotFoundPage = (): ReactElement => {
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		console.log(location.pathname)
		const missingPage = location.pathname.replace(/^\//, "");
		navigate(`/${PAGES_PATHS.ERROR}?${ErrorParam.KEY}=${ErrorCode.PAGE_NOT_FOUND}&${ErrorParam.REQUESTED_PAGE}=${encodeURIComponent(missingPage)}`, {replace: true});
	}, [location.pathname, navigate]);

	return <React.Fragment/>;
};
